import { render } from "./OPINION_NEW_MADE_PUBLIC_BY_ORG.vue?vue&type=template&id=78a68fa6"
import script from "./OPINION_NEW_MADE_PUBLIC_BY_ORG.vue?vue&type=script&lang=js"
export * from "./OPINION_NEW_MADE_PUBLIC_BY_ORG.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__